const {
  LICENSING_API_HOST, EMPLOYEE_MYCITRIX_DOMAIN,
  EMPLOYEE_MYCITRIX_HOST, EXTERNAL_MYCITRIX_DOMAIN, EXTERNAL_MYCITRIX_HOST, RECENT_PURCHASES_URL_PREFIX, RECENT_PURCHASES_URL_SUFFIX,
  EXPIRING_LICENSES_URL_PREFIX, EXPIRING_LICENSES_URL_SUFFIX, ALL_LICENSES_URL, LICENSES_URL,
  NOTES_URL, ACTIVITY_URL, PRIME_CACHE_URL, EASY_URL, ARCHIVE_URL, RETURN_URL,
  EXPORT_CSV_URL, ALLOCATE_URL, ALLOCATE_DROPDOWN_URL_PREFIX, MODIFY_URL, METAFRAME_ELIGIBILITY_URL,
  ALLOCATE_DROPDOWN_URL_SUFFIX, DOWNLOAD_URL, ALLOW_PARTIAL_URL_PREFIX, ALLOW_PARTIAL_URL_SUFFIX,
  HARDWARE_ELIGIBILITY_URL, METAFRAME_URL, HARDWARE_URL, SAVE_NOTES_URL, WEBKEY_URL,
  RENEW_LICENSES_URL, UPGRADE_LICENSES_URL, ALLOCATE_EASY_URL, ALLOW_PARTIAL_EASY_URL_PREFIX,
  DOWNLOAD_EASY_URL, EASY_PAGE_SIGN_IN_SUBDOMAIN, EASY_PAGE_SIGN_IN_URL, ALL_ASSETS_SEARCH_URL,
  ALL_ASSETS_EXPORT_URL, LA_007_SEARCH_URL, LA_007_MODIFY_URL, RESEND_EMAIL_URL, SURVEY_APPLICATION_NAME,
  SURVEY_LICENSE_ACTION_RETURN, SURVEY_LICENSE_ACTION_ALLOCATE, SURVEY_APIKEY, SURVEY_FETCH_API_URL, SURVEY_STORE_TRANSACTION_API_URL,
  AUTH_SERVICE_URL,
  PERSON_SERVICE_URL,
  PERSON_SERVICE_URL_INTERNAL,
  LICENSE_SURVEY_URL, SURVEY_ID,
  DOWNLOAD_UBER_AGENT_LIC_URL, UBER_AGENT_DETAILS_URL,
  NON_STANDARD_LIC_DETAILS_URL, DOWNLOAD_NON_STANDARD_LIC_URL,
  GET_DOMAINS_FOR_STRONG_URL, SAVE_DOMAINS_FOR_STRONG_URL,
  GET_USERS_FOR_UNICON_URL, SAVE_USER_FOR_UNICON_URL,
  SURVEY_LICENSE_ACTION_XSALLOCATE, LICENSE_SURVEY_URL_XS, SURVEY_ID_XS
} = process.env
const { hostname, protocol } = location
const licensingBasePrefix = `${protocol}//${LICENSING_API_HOST}`

const UrlBuilder = {}
UrlBuilder.install = Vue => {
  Vue.prototype.UrlBuilder = UrlBuilder
}
UrlBuilder.employeeBaseUrl = `${protocol}//${EMPLOYEE_MYCITRIX_HOST}.${EMPLOYEE_MYCITRIX_DOMAIN}`
UrlBuilder.externalBaseUrl = `${protocol}//${EXTERNAL_MYCITRIX_HOST}.${EXTERNAL_MYCITRIX_DOMAIN}`
UrlBuilder.isInternalUser = hostname.includes(EMPLOYEE_MYCITRIX_DOMAIN)
UrlBuilder.myCitrixBaseUrl = UrlBuilder.isInternalUser
  ? UrlBuilder.employeeBaseUrl
  : UrlBuilder.externalBaseUrl
UrlBuilder.licensingBaseUrl = UrlBuilder.isInternalUser
  ? `${licensingBasePrefix}.${EMPLOYEE_MYCITRIX_DOMAIN}`
  : `${licensingBasePrefix}.${EXTERNAL_MYCITRIX_DOMAIN}`
// UrlBuilder.licensingBaseUrl = `https://masdwebidev05.citrite.net`
UrlBuilder.authenticationUrl = `${UrlBuilder.myCitrixBaseUrl}${AUTH_SERVICE_URL}`
UrlBuilder.accountUrl = (loginId = '') => {
  return loginId.length <= 0
          ? `${UrlBuilder.myCitrixBaseUrl}${PERSON_SERVICE_URL}`
          : `${UrlBuilder.licensingBaseUrl}${PERSON_SERVICE_URL_INTERNAL}/username/${loginId}/`
}
UrlBuilder.recentPurchasesUrl = customerId =>
  `${UrlBuilder.licensingBaseUrl}${RECENT_PURCHASES_URL_PREFIX}${customerId}${RECENT_PURCHASES_URL_SUFFIX}`
UrlBuilder.expiringLicensesUrl = customerId =>
  `${UrlBuilder.licensingBaseUrl}${EXPIRING_LICENSES_URL_PREFIX}${customerId}${EXPIRING_LICENSES_URL_SUFFIX}`
UrlBuilder.allLicensesUrl = `${UrlBuilder.licensingBaseUrl}${ALL_LICENSES_URL}`
UrlBuilder.licenseDetailUrl = (customerId, activationId) =>
`${UrlBuilder.licensingBaseUrl}${EXPIRING_LICENSES_URL_PREFIX}${customerId}${LICENSES_URL}${activationId}`
UrlBuilder.licenseDetailNotesUrl = (customerId, activationId) =>
`${UrlBuilder.licensingBaseUrl}${EXPIRING_LICENSES_URL_PREFIX}${customerId}${LICENSES_URL}${activationId}${NOTES_URL}`
UrlBuilder.licenseDetailActivityLogUrl = (customerId, activationId) =>
`${UrlBuilder.licensingBaseUrl}${EXPIRING_LICENSES_URL_PREFIX}${customerId}${LICENSES_URL}${activationId}${ACTIVITY_URL}`
UrlBuilder.getCadsFromCacheUrl = customerId =>
`${UrlBuilder.licensingBaseUrl}${EXPIRING_LICENSES_URL_PREFIX}${customerId}${PRIME_CACHE_URL}`
UrlBuilder.entitlementByIdUrl = entitlementId =>
`${UrlBuilder.licensingBaseUrl}${EXPIRING_LICENSES_URL_PREFIX}${EASY_URL}${entitlementId}`
UrlBuilder.exportCsvUrl = `${UrlBuilder.licensingBaseUrl}${EXPORT_CSV_URL}`
UrlBuilder.getAllocateUrl = (fromEasy = false) => fromEasy
  ? `${UrlBuilder.licensingBaseUrl}${ALLOCATE_EASY_URL}`
  : `${UrlBuilder.licensingBaseUrl}${ALLOCATE_URL}`
UrlBuilder.getAllocateDropdownUrl = (activationId, customerId) =>
  `${UrlBuilder.licensingBaseUrl}${ALLOCATE_DROPDOWN_URL_PREFIX}${activationId}/${customerId}${ALLOCATE_DROPDOWN_URL_SUFFIX}`
UrlBuilder.getDownloadUrl = (fromEasy = false) => fromEasy
  ? `${UrlBuilder.licensingBaseUrl}${DOWNLOAD_EASY_URL}`
  : `${UrlBuilder.licensingBaseUrl}${DOWNLOAD_URL}`
UrlBuilder.getAllowPartialUrl = (activationId, customerId, serialNumber, fromEasy = false) =>
  fromEasy
    ? `${UrlBuilder.licensingBaseUrl}${ALLOW_PARTIAL_EASY_URL_PREFIX}${activationId}/${customerId}/${serialNumber}${ALLOW_PARTIAL_URL_SUFFIX}`
    : `${UrlBuilder.licensingBaseUrl}${ALLOW_PARTIAL_URL_PREFIX}${activationId}/${customerId}/${serialNumber}${ALLOW_PARTIAL_URL_SUFFIX}`
UrlBuilder.archiveLicensesUrl = `${UrlBuilder.licensingBaseUrl}${ARCHIVE_URL}`
UrlBuilder.returnUrl = `${UrlBuilder.licensingBaseUrl}${RETURN_URL}`
UrlBuilder.saveNotesUrl = `${UrlBuilder.licensingBaseUrl}${SAVE_NOTES_URL}`
UrlBuilder.easyUrl = `${UrlBuilder.licensingBaseUrl}${EASY_URL}`
UrlBuilder.modifyUrl = `${UrlBuilder.licensingBaseUrl}${MODIFY_URL}`
UrlBuilder.getMetaframeEligibilityUrl = customerId =>
  `${UrlBuilder.licensingBaseUrl}${ALLOCATE_DROPDOWN_URL_PREFIX}${customerId}${METAFRAME_ELIGIBILITY_URL}`
UrlBuilder.getHardwareEligibilityUrl = customerId =>
  `${UrlBuilder.licensingBaseUrl}${ALLOCATE_DROPDOWN_URL_PREFIX}${customerId}${HARDWARE_ELIGIBILITY_URL}`
UrlBuilder.metaframeUrl = `${UrlBuilder.myCitrixBaseUrl}${METAFRAME_URL}`
UrlBuilder.hardwareUrl = `${UrlBuilder.myCitrixBaseUrl}${HARDWARE_URL}`
UrlBuilder.getWebkeyUrl = (value, customerId) =>
  `${UrlBuilder.licensingBaseUrl}${ALLOCATE_DROPDOWN_URL_PREFIX}${value}/${customerId}${WEBKEY_URL}`
UrlBuilder.customerServiceUrl = 'https://www.citrix.com/support/open-a-support-case/'
UrlBuilder.citrixLicensingDocumentationUrl = 'https://docs.citrix.com/en-us/licensing/current-release.html'
UrlBuilder.docsUrl = 'https://docs.citrix.com/'
UrlBuilder.renewLicensesUrl = `${UrlBuilder.myCitrixBaseUrl}${RENEW_LICENSES_URL}`
UrlBuilder.upgradeLicensesUrl = `${UrlBuilder.myCitrixBaseUrl}${UPGRADE_LICENSES_URL}`
UrlBuilder.getLicensingFaqsUrl = locale =>
  `https://docs.citrix.com/${locale}/licensing/current-release/frequently-asked-questions.html`
UrlBuilder.easyPageSignInUrl =
  `${protocol}//${EASY_PAGE_SIGN_IN_SUBDOMAIN}${EXTERNAL_MYCITRIX_DOMAIN}${EASY_PAGE_SIGN_IN_URL}`
UrlBuilder.allAssetsSearchUrl = `${UrlBuilder.licensingBaseUrl}${ALL_ASSETS_SEARCH_URL}`
UrlBuilder.allAssetsExportUrl = `${UrlBuilder.licensingBaseUrl}${ALL_ASSETS_EXPORT_URL}`
UrlBuilder.getLa007SearchUrl = (searchInput) =>
  `${UrlBuilder.licensingBaseUrl}${LA_007_SEARCH_URL}${searchInput}`
UrlBuilder.la007ModifyUrl = `${UrlBuilder.licensingBaseUrl}${LA_007_MODIFY_URL}`
UrlBuilder.resendEmailUrl = `${UrlBuilder.licensingBaseUrl}${RESEND_EMAIL_URL}`
UrlBuilder.surveyAPIUrl = `${SURVEY_FETCH_API_URL}`
UrlBuilder.surveyTransactionAPIUrl = `${SURVEY_STORE_TRANSACTION_API_URL}`
UrlBuilder.surveyAppName = `${SURVEY_APPLICATION_NAME}`
UrlBuilder.licenseActionReturn = `${SURVEY_LICENSE_ACTION_RETURN}`
UrlBuilder.licenseActionAllocate = `${SURVEY_LICENSE_ACTION_ALLOCATE}`
UrlBuilder.licenseActionXSAllocate = `${SURVEY_LICENSE_ACTION_XSALLOCATE}`
UrlBuilder.surveyAPIKey = `${SURVEY_APIKEY}`
UrlBuilder.surveyUrl = `${LICENSE_SURVEY_URL}`
UrlBuilder.surveyId = `${SURVEY_ID}`
UrlBuilder.XSSurveyUrl = `${LICENSE_SURVEY_URL_XS}`
UrlBuilder.XSSurveyId = `${SURVEY_ID_XS}`
UrlBuilder.endUserLicenseAgreement = 'https://www.citrix.com/en-gb/buy/licensing/agreements.html'
UrlBuilder.rightToAuditCompliance = 'https://www.citrix.com/about/legal/product-license-compliance.html'
UrlBuilder.warningLicenseRehostLink = 'https://support.citrix.com/article/CTX134629'
UrlBuilder.getUberAgentDetails = customerId =>
`${UrlBuilder.licensingBaseUrl}${UBER_AGENT_DETAILS_URL}${customerId}`
UrlBuilder.downloadUberAgentLic = (customerName, Quantity, Expiry, AssetComponentId) =>
  `${UrlBuilder.licensingBaseUrl}${DOWNLOAD_UBER_AGENT_LIC_URL}${customerName}/${Quantity}/${Expiry}/${AssetComponentId}`
UrlBuilder.getNonStandardLICDetails = customerId =>
  `${UrlBuilder.licensingBaseUrl}${NON_STANDARD_LIC_DETAILS_URL}${customerId}`
UrlBuilder.downloadNonStandardLic = (nsLicType, customerId) =>
  `${UrlBuilder.licensingBaseUrl}${DOWNLOAD_NON_STANDARD_LIC_URL}${nsLicType}/${customerId}`
UrlBuilder.getDomainsListForStrong = (customerId) =>
  `${UrlBuilder.licensingBaseUrl}${GET_DOMAINS_FOR_STRONG_URL}${customerId}`
UrlBuilder.saveDomainsForStrong = (customerId) =>
  `${UrlBuilder.licensingBaseUrl}${SAVE_DOMAINS_FOR_STRONG_URL}${customerId}`
UrlBuilder.getUserListForUnicon = (customerId) =>
  `${UrlBuilder.licensingBaseUrl}${GET_USERS_FOR_UNICON_URL}${customerId}`
UrlBuilder.updateUserListForUnicon = () => `${UrlBuilder.licensingBaseUrl}${SAVE_USER_FOR_UNICON_URL}`
export default UrlBuilder



// WEBPACK FOOTER //
// ./src/plugins/UrlBuilder.js